const adminRouter = [{
  path: '',
  redirect: 'scoreList'
},
  {
    path: 'scoreList',
    meta: {title: '评估打分表'},
    component: () => import ('../views/admin/scoreTable/scoreList'),
  },
  {
    path: 'scoreEdit/:id',
    meta: {title: '评估打分表-编辑'},
    component: () => import ('../views/admin/scoreTable/scoreEdit'),
  },
  {
    path: 'scoreShow/:id',
    meta: {title: '评估打分表-预览'},
    component: () => import ('../views/admin/scoreTable/scoreShow'),
  },
  {
    path: 'estimateOrg/:id',
    meta: {title: '评估打分表-参评社会组织管理'},
    component: () => import ('../views/admin/scoreTable/estimateOrg'),
  },
  {
    path: 'estimateOrgEdit/:id/:sid',
    meta: {title: '评估打分表-参评机构编辑'},
    component: () => import ('../views/admin/scoreTable/estimateOrgEdit'),
  },
  {
    path: 'estimateOrgShow/:id/:sid',
    meta: {title: '评估打分表-参评机构预览'},
    component: () => import ('../views/admin/scoreTable/estimateOrgShow'),
  },
  {
    path: 'estimateExpert/:id',
    meta: {title: '评估打分表-参评专家管理'},
    component: () => import ('../views/admin/scoreTable/estimateExpert'),
  },
  {
    path: 'orgList',
    meta: {title: '社会组织管理'},
    component: () => import ('../views/admin/orgList/orgList'),
  },
  {
    path: 'expertList',
    meta: {title: '专家管理'},
    component: () => import ('../views/admin/expertList/expertList'),
  },


]
export default adminRouter
